import script from "./ImportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportModal.vue?vue&type=script&setup=true&lang=ts"

import "./ImportModal.vue?vue&type=style&index=0&id=ff63c4f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff63c4f0"]])

export default __exports__